export default "__VITE_ASSET__09e7df39__"